import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-manager',
  templateUrl: './promotion-manager.component.html',
  styleUrls: ['./promotion-manager.component.css']
})
export class PromotionManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
